module.exports = __webpack_public_path__ + "img/symbol_4.037bbb40.png";